export default "__VITE_ASSET__CyjtC5Jq__"